module.exports = __webpack_public_path__ + "img/job-icon-3.cb3592cf.png";